<template>
  <div>
    <div slot="toolbar" style="display: flex;flex-direction: row;justify-content: space-between;">
      <el-button type="primary" style="margin-bottom: 1%" @click="$refs.editSystemNavItem.open(0)">
        新建
      </el-button>
      <div style="display: flex;flex-direction: row; height: 28px;">
        <el-input v-model="inputFilter" style="margin-bottom: 1%;" placeholder="请输入内容" clearable/>
        <div class="ad-search-btn">
          <el-button
              type="primary"
              size="mini"
              style="margin-bottom: 1%; margin-left: 5px;"
              @click="handleSearchClick">
            查询
          </el-button>
        </div>
      </div>
    </div>
    <el-table
        v-loading="status==='loading'"
        :data="tableData"
        style="width: 100%"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="getList">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column
          width="180"
          label="名称"
          prop="other.title"/>
      <el-table-column
          label="ID"
          prop="other.id"
          width="80"/>
      <el-table-column
          label="HREF"
          prop="other.href"/>
      <el-table-column
          label="菜单类型"
          prop="other.category">
        <template slot-scope="scope">
          <span>{{categorys[scope.row.other.category]}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="图标"
          prop="other.image"/>
      <el-table-column
          label="级别"
          prop="other.level"
          width="50"/>
      <el-table-column
          label="SeqNO"
          prop="other.seqNO"
          width="80"/>
      <el-table-column
          label="功能"
          prop="other.functionName"/>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="info" @click="$refs.editSystemNavItem.open(scope.row.id)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <system-nav-item-edit ref="editSystemNavItem" @save-success="getList(1)"/>
    <system-nav-item-create ref="editSystemNavItemNew" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import SystemNavItemEdit from "@/views/SystemInfo/systemNavItem/SystemNavItemEdit";
  import SystemNavItemCreate from "@/views/SystemInfo/systemNavItem/SystemNavItemCreate";
  export default {
    name: "SystemNavItemList",
    components: {SystemNavItemCreate, SystemNavItemEdit},
    data() {
      return{
        status: "loading",
        constant,
        categorys: constant.category,
        tableData: [],
        inputFilter: "",
        filter:{
          filter: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        this.status = "loading";
        this.$http
          .get("basic","navItems/tree",this.filter)
          .then((resp)=>{
            this.tableData = resp;
            if (resp.length === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          }).catch(() => {
            this.status = "error";
          });
      },
      handleSearchClick() {
        this.filter.filter = this.inputFilter;
        this.getList();
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","navItems",row.id)
            .then(() => {
              this.getList();
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
